import $ from "jquery"
class AutoHeight {
  constructor(vue) {
    this.context = vue
  }
  init() {
    this.context.$refs.multiFilter.style.height = "auto"
    this.context.$on("hook:mounted", () => {
      !this.checkIsDrawer() && this.resetHeight()
    })
    this.context.$on("hook:updated", () => {
      !this.checkIsDrawer() && this.resetHeight()
    })
  }
  checkIsDrawer() {
    return this.context.options.indrawer
  }
  resetHeight() {
    this.context.$nextTick(() => {
      const container = $(this.context?.$refs?.multiFilter).parents(".layout-columns")
      const layoutRow = $(this.context?.$refs?.multiFilter).parents(".layout-row.layout-box")
      const multiFilterHeight = this.context.$refs.multiFilter.offsetHeight
      if (container && container.length) {
        $(container[0]).css("box-sizing", "content-box")
        $(container[0]).css("height", multiFilterHeight + "px")
      }
      if (layoutRow && layoutRow.length) {
        $(layoutRow[0]).css("max-height", multiFilterHeight + "px")
      }
    })
  }
}
export default {
  methods: {
    autoHeight() {
      new AutoHeight(this).init()
    }
  }
}
